import { render, staticRenderFns } from "./Estudante.vue?vue&type=template&id=5d2a8d92&scoped=true&"
import script from "./Estudante.vue?vue&type=script&lang=js&"
export * from "./Estudante.vue?vue&type=script&lang=js&"
import style0 from "./Estudante.vue?vue&type=style&index=0&id=5d2a8d92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a8d92",
  null
  
)

export default component.exports